export default __webpack_public_path__ + "static/media/conjure-logo-Samla.3e6034cf.svg";